<template>
  <view-wrap>
    <template class="top">
      <div id="profile">
        <div class="profile-pic">
          <!-- <p class="profile-emoji" :style="{'color': color()}">☺</p> -->
          <img :src="profilePic" />
        </div>
      </div>
    </template>
    <template v-slot:full>
      <view-wrap class="bg-light">
        <div class="bottom bg-light">
          <h1>{{ currentUser.nickname }}</h1>
          <p class="email">{{ currentUser.email }}</p>
          <button class="dark log-out" @click="logout()">Logout</button>
        </div>
      </view-wrap>
    </template>
  </view-wrap>
</template>

<script>
  export default {
    name: "profile",
    data () {
      return {
        manager: {}
      }
    },
    created: async function () {
      if(this.$store.getters.manager) {
        this.manager = this.$store.getters.manager;
      }
      else { 
        try {
          this.$store.dispatch("isLoading", true);
          this.manager = await this.$store.state.apiService.getManager()
        } 
        catch (e) {
          if (e.response && e.response.status && e.response.status === 403) {
            this.$store.dispatch("login", true);
          }
        } 
        finally {
          this.$store.dispatch("isLoading", false); 
        }
      }
    },
    components: {},
    computed: {
      profilePic: function () {
        if (!this.currentUser.image_url || this.currentUser.image_url.indexOf('default') > -1) {
          return require('./images/profile.png')
        } else {
          return this.currentUser.image_url
        }
      },
      currentUser: function () {
        return this.manager || this.$store.getters.manager || {}
      }
    },
    methods: {
      logout: async function () {
        await this.$store.dispatch('logout')
        if (!this.$store.getters.currentUser) this.$router.push('home')
      },
      color: function () {
        return 'rgba(' + String(Math.floor(Math.random() * 80) + 1) + ', ' + String(Math.floor(Math.random() * 80) + 1) + ', ' + String(Math.floor(Math.random() * 80) + 1) + ', 1)'
      }
    }
  };
</script>

<style src="./profile.styl" lang="stylus" scoped></style>
